import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAddresses } from '../store/feature/addressSlice';
import { fetchPhones } from '../store/feature/phoneSlice';
import { AppDispatch, RootState } from '../store';
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import './Contact.css';
import AppBar from '../components/Navbar';

const Contact: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { addresses } = useSelector((state: RootState) => state.address);
  const { phones, loading, error } = useSelector((state: RootState) => state.phone);

  useEffect(() => {
    dispatch(fetchAddresses());
    dispatch(fetchPhones());
  }, [dispatch]);

  return (
    <div>
      <AppBar />
      <div className="contact-page">
        <div className="contact-container">
          <h2 className="contact-title">Bizimle İletişime Geçin</h2>

          <>
            {/* Addresses Section */}
            <div className="addresses-section">
              <h3 className="section-title">
                <FaMapMarkerAlt /> {'Adreslerimiz'}
              </h3>
              {addresses.length === 0 ? (
                <p className="no-data">Adres bulunamadı</p>
              ) : (
                <ul className="address-list">
                  {addresses.map((address: { id: number; description: string; value: string }) => (
                    <li key={address.id} className="address-item">
                      <strong>{address.description}</strong>{' '}
                      <a
                        href={`https://www.google.com/maps?q=${encodeURIComponent(address.value)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="address-link"
                      >
                        {address.value}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <hr className="divider" />

            {/* Phones Section */}
            <div className="phones-section">
              <h3 className="section-title">
                <FaPhoneAlt /> {'Telefon Numaramız'}
              </h3>
              {loading ? (
                <p className="no-data">Yükleniyor...</p>
              ) : error ? (
                <p className="no-data">{error}</p>
              ) : phones.length === 0 ? (
                <p className="no-data">Telefon numarası bulunamadı</p>
              ) : (
                <ul className="phone-list">
                  {phones.map((phone: { id: number; description: string; value: string }) => (
                    <li key={phone.id} className="phone-item">
                      <strong>{phone.description}</strong>{' '}
                      <a href={`tel:${phone.value}`} className="phone-link">
                        {phone.value}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <hr className="divider" />

            {/* Email Section */}
            <div className="email-section">
              <h3 className="section-title">
                <FaEnvelope /> {'E-mail'}
              </h3>
              <p className="email-item">
                <a href="mailto:istanbulyerbilimleri@gmail.com" className="email-link">
                  istanbulyerbilimleri@gmail.com
                </a>
              </p>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Contact;